const i18n = {
  'en-US': {
    'menu.knowledgeCheck.list': 'KnowledgeCheck',
    'menu.knowledge.graph': 'knowledgeGraph',
    'menu.zhisiti.index': 'Zhisiti',
    'menu.organizational.management': 'Organizational Management',
    'menu.system.course': 'Course System',
    'menu.exception': 'Exception',
    'menu.user': 'User Center',
    'menu.exception.403': '403',
    'menu.exception.404': '404',
    'menu.exception.500': '500',
    'menu.user.info': 'User Info',
    'navbar.logout': 'Logout',
    'settings.title': 'Settings',
    'settings.themeColor': 'Theme Color',
    'settings.content': 'Content Setting',
    'settings.navbar': 'Navbar',
    'settings.menuWidth': 'Menu Width (px)',
    'settings.navbar.theme.toLight': 'Click to use light mode',
    'settings.navbar.theme.toDark': 'Click to use dark mode',
    'settings.menu': 'Menu',
    'settings.footer': 'Footer',
    'settings.otherSettings': 'Other Settings',
    'settings.colorWeek': 'Color Week',
    'settings.alertContent':
      'After the configuration is only temporarily effective, if you want to really affect the project, click the "Copy Settings" button below and replace the configuration in settings.json.',
    'settings.copySettings': 'Copy Settings',
    'settings.copySettings.message':
      'Copy succeeded, please paste to file src/settings.json.',
    'settings.close': 'Close',
    'settings.color.tooltip':
      '10 gradient colors generated according to the theme color',
    'message.tab.title.message': 'Message',
    'message.tab.title.notice': 'Notice',
    'message.tab.title.todo': 'ToDo',
    'message.allRead': 'All Read',
    'message.seeMore': 'SeeMore',
    'message.empty': 'Empty',
    'message.empty.tips': 'No Content',
    'message.lang.tips': 'Language switch to ',
    'navbar.search.placeholder': 'Please search',
    'menu.system.admin': 'System Admin',
    'menu.sipu.ability': 'menu.sipu.ability',
    'menu.sipu.quality': 'menu.sipu.quality',
    'menu.sipu.employment': 'menu.sipu.employment',
  },
  'zh-CN': {
    'menu.knowledgeCheck.list': '知识查查',
    'menu.knowledge.graph': '知识图谱',
    'menu.zhisiti.index': '智思体',
    'menu.organizational.management': '组织管理',
    'menu.system.course': '课程体系',
    'menu.exception': '异常页',
    'menu.user': '个人中心',
    'menu.exception.403': '403',
    'menu.exception.404': '404',
    'menu.exception.500': '500',
    'menu.user.info': '用户信息',
    'navbar.logout': '退出登录',
    'settings.title': '页面配置',
    'settings.themeColor': '主题色',
    'settings.content': '内容区域',
    'settings.navbar': '导航栏',
    'settings.menuWidth': '菜单宽度 (px)',
    'settings.navbar.theme.toLight': '点击切换为亮色模式',
    'settings.navbar.theme.toDark': '点击切换为暗黑模式',
    'settings.menu': '菜单栏',
    'settings.footer': '底部',
    'settings.otherSettings': '其他设置',
    'settings.colorWeek': '色弱模式',
    'settings.alertContent':
      '配置之后仅是临时生效，要想真正作用于项目，点击下方的 "复制配置" 按钮，将配置替换到 settings.json 中即可。',
    'settings.copySettings': '复制配置',
    'settings.copySettings.message':
      '复制成功，请粘贴到 src/settings.json 文件中',
    'settings.close': '关闭',
    'settings.color.tooltip':
      '根据主题颜色生成的 10 个梯度色（将配置复制到项目中，主题色才能对亮色 / 暗黑模式同时生效）',
    'message.tab.title.message': '消息',
    'message.tab.title.notice': '通知',
    'message.tab.title.todo': '待办',
    'message.allRead': '全部已读',
    'message.seeMore': '查看更多',
    'message.empty': '清空',
    'message.empty.tips': '暂无内容',
    'message.lang.tips': '语言切换至 ',
    'navbar.search.placeholder': '输入内容查询',
    'menu.system.role': '权限管理',
    'menu.system.dictionary': '字典管理',
    'menu.system.personal': '个人中心',
    'menu.system.pro': '专题项目',
    'menu.system.scheme': '培养方案',
    'menu.system.schemeList': '培养方案列表',
    'menu.system.schemeIndex': '培养方案详情',
    'menu.system.admin': '系统管理',
    'menu.explore.index': '知识探索',
    'menu.researchCenter.admin': '专业研究发展中心',
    'menu.researchCenter.development': '专业发展研究中心',
    'menu.researchCenter.direction': '研究方向管理',
    'menu.sipu.admin': '专业四谱画像',
    'menu.sipu.ability': '能力图谱',
    'menu.sipu.quality': '素养图谱',
    'menu.sipu.employment': '就业数据',
    'menu.atlasAi.admin': '智思体专业分析',
    'menu.atlasAi.home': '人才培养画像',
    'menu.atlasAi.fit': '专业契合度',
    'menu.atlasAi.scheme': '培养方案分析',
    'menu.atlasAi.employment': '毕业生行业数据分析',
    'menu.atlasAi.detail': 'AI专业分析详情',
  },
};

export default i18n;
